import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import AccountCreationBlackboard from './account-creation-blackboard';
import { PanelAPI, ToastNotificationAPI } from '@philips-internal/oswald-ui-components';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

@Controller({ fragment: 'account-creation-completed', component: 'layout-account-creation-completed' })
export default class AccountCreationCompletedController extends BaseController {

  @Inject('toast-account-creation-error')
  toast: ToastNotificationAPI;

  @Inject('AccountCreationBlackboard')
  accountCreationBlackboard: AccountCreationBlackboard;

  @Inject('panel-success')
  panelSuccess: PanelAPI;

  @OnMount({ target: 'button-close' })
  onMountAccountCreationCompleted(): void {
    const { errorMessage } = this.accountCreationBlackboard.accountData;

    if (errorMessage) {
      this.panelSuccess.setVisible(false);
      this.toast.setVisible(true);
      this.toast.setMessage(errorMessage as string);
    }
  }

  @OnClick({ target: 'button-close' })
  onCloseModalAccountCreation(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

}